import React, {useState} from 'react';
import { Row, Col, Badge, Table } from 'react-bootstrap';
import { number_format } from '../../utils/utils';
import { ModalMarcarPago, ModalConfirmacion,ModalFaltaPago,ModalCancelarPoliza } from '../../utils/modals';
import toast, { Toaster } from 'react-hot-toast';

import { useSelector,useDispatch } from 'react-redux';
import { setInitData,quitarPagoRecibo } from '../../reducers/appReducer';

const TablaRecibos = ({state,setState,filteredData,handleShowModalRecibo}) => {

  const initData = useSelector( (state) => state.agents.initData );
  const stateHome = useSelector( (state) =>  state.agents.home );
  const { isLoadPanel,section } = stateHome;
  const dispatch = useDispatch();
  let colorLabel = "green";
  if(section===2) colorLabel = "green";
  if(section===3) colorLabel = "#FF3624";

  const [stateRecibo,setStateRecibo] = useState({
    isLoading: false,
    error: false,
    errorMessage: '',
  })

  const [modalMarcarPago,setModalMarcarPago] = useState(false);
  const [modalConfirmacion,setModalConfirmacion] = useState(false);
  const [modalFaltaPago,setModalFaltaPago] = useState(false);
  const [modalCancelarPoliza,setModalCancelarPoliza] = useState(false);
  const [dataSelected,setDataSelected] = useState([]);
  const [nombreCompania,setNombreCompania] = useState('');
  const [numeroPoliza,setNumeroPoliza] = useState('');

  const handleShowModalMarcarPago = () => setModalMarcarPago(true);
  const handleCloseModalMarcarPago = () => setModalMarcarPago(false);

  const handleShowModalConfirmacion = () => setModalConfirmacion(true);
  const handleCloseModalConfirmacion = () => setModalConfirmacion(false);

  const handleShowModalFaltaPago = () => setModalFaltaPago(true);
  const handleCloseModalFaltaPago = () => setModalFaltaPago(false);

  const handleShowModalCancelarPoliza = () => setModalCancelarPoliza(true);
  const handleCloseModalCancelarPoliza = () => setModalCancelarPoliza(false);

  const quitarPago = () => {

    setStateRecibo({
      ...stateRecibo,
      isLoading: true
    })

    var formData = new FormData();
    const { id_historial, nombre_usuario, numero_poliza } = dataSelected;
    formData.append('id_historial',id_historial);
    formData.append('nombre_cliente',nombre_usuario);
    formData.append('numero_poliza',numero_poliza);

    fetch('REST/controllers/mainController?opt=quitarPago',{
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then( response => response.json() )
    .then( response => {

      let arrFrom;
      if(section===1) arrFrom = 'arrPorPagar'
      if(section===2) arrFrom = 'arrPagados'
      if(section===3) arrFrom = 'arrVencidos'
      if(section===4) arrFrom = 'arrRenovaciones'

      setStateRecibo({
        ...stateRecibo,
        isLoading: false
      })

      dispatch( quitarPagoRecibo( { 
        section : arrFrom,
        poliza : numero_poliza,
      } ) )

      handleCloseModalConfirmacion();
      toast.success( (e) => (
        <p className="mb-0">Desmarcaste el pago de la póliza: <b>{numero_poliza}</b>.</p>
      ),{
        duration: 4000
      }); 
    })
  }

  const showToast = (message) => {
    toast.success( (e) => (
      <p className="mb-0">{message}</p>
    ),{
      duration: 2000
    });
  }

  return(
    <Row>
      <Col xs={12} className="mb-4">
        <div className="ws-box-container">
          { (isLoadPanel) && (<div className="ws-loader-container"><div className="spinner"></div></div>) }
          <h4>Recibos</h4>
          <Table responsive hover>
            <thead>
              <tr>
                <th width="26%">Nombre</th>
                <th width="15%">Periodo</th>
                <th width="25%">Compañia</th>
                <th width="24%">Fecha</th>
                <th width="10%">Opciones</th>
              </tr>
          </thead>
          <tbody>

            {
              (filteredData.length < 1) && (
                <tr>
                  <td colSpan={5}> 
                    <p className="text-center mt-2 mb-2"><b>No hay resultados</b></p>
                  </td>
                </tr>
              )
            }

            {
              (filteredData.length > 0) && (
                filteredData.map((t,e) => (
                  <tr key={e}>
                    <td>
                      <div style={{display:'inline-block',textAlign:'center',lineHeight:'37px',width:'37px',height:'35px',backgroundColor:colorLabel,color:'#fff',borderRadius:'3px',float:'left'}}>
                        {(t.forma_pago==='e') ? 'EF' : 'CT'}
                      </div>
                      <div style={{display:'inline-block',float:'left',paddingLeft:'5px'}}>
                        <p className="mb-0">{t.nombre_usuario}</p>
                        <p className="mb-0" style={{color:'#777',fontSize:'.9rem'}}>{t.nombre_creador}</p>
                      </div>
                    </td>
                    <td>
                      <p className="mb-0">
                        {t.numero_poliza}
                        {
                          (t.recibo!=='') ? <span className="ws-tooltip-top" data-tooltip="Tiene una observación"><span style={{width:'10px',height:'10px',borderRadius:'50%',backgroundColor:'#ff355c',display:'inline-block',marginLeft:'5px'}}></span></span> : ''
                        }
                      </p>
                      <Badge className="ws-bg-info">{t.tipo_pago}</Badge>
                      {
                        (t.recibo_numero == t.recibo_total) ?
                          (t.recibo_total == 1) ?  <Badge className="ws-bg-info ms-1">Pago único</Badge> : <Badge className="ws-bg-info ms-1">Último recibo</Badge>
                        : null
                      }
                      {/* <span className="badge ws-bg-info"></span> */}
                    </td>
                    <td>
                      <p className="mb-0">{ (typeof initData.companies !== 'undefined') ? initData.companies.filter( company => company.id_compania == t.id_compania)[0].nombre : ' - ' }</p>
                      <Badge className="ws-bg-info">{ (typeof initData.ramos !== 'undefined') ? initData.ramos.filter( ramos => ramos.id_padre == t.id_padre )[0].nombre : ' - ' }</Badge>
                    </td>
                    <td>
                      <p className="mb-0">
                        {t.mes_completo.split(' ')[0]}
                        {
                          (t.fecha_realizado.split(' ')[0]!=='0000-00-00') ? <span className="ws-tooltip-top" data-tooltip={t.fecha_realizado_text}><span style={{width:'10px',height:'10px',borderRadius:'50%',backgroundColor:'#ff355c',display:'inline-block',marginLeft:'5px'}}></span></span> : ''
                        }
                      </p>
                      <p className="mb-0">
                        <span className="ws-type-currency">{t.moneda}</span>
                        &nbsp;${ number_format(t.prima) }
                      </p>
                      {
                        (t.count_endosos>0) && (
                          <Badge className="ws-bg-info">{t.count_endosos} {(t.count_endosos>1) ? 'endosos' : 'endoso'}</Badge>
                        )
                      }
                    </td>
                    <td>
                      <ul className="navbar-nav ms-auto ws-dropdown-list">
                        <li className="nav-item dropdown position-static">
                          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                            <i className="bi bi-three-dots-vertical"></i>
                          </a>
                          <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                            {/* QUITAR/MARCAR PAGO */}
                            { (t.status === 1) && ( <a className="dropdown-item" href="#"
                            onClick={ () => {
                              setDataSelected(t);
                              setNumeroPoliza(t.numero_poliza);
                              handleShowModalConfirmacion();
                            } }
                            ><i className="bi bi-x-circle-fill pe-2"></i> Quitar pago</a> ) }
                            { (t.status === 0) && ( <a className="dropdown-item" href="#" 
                            onClick={
                              () => {
                                const nombre_compania = (typeof initData.companies !== 'undefined') ? initData.companies.filter( company => company.id_compania == t.id_compania)[0].nombre : '';
                                setNombreCompania(nombre_compania);
                                setDataSelected(t);
                                handleShowModalMarcarPago();
                              }
                            }
                            ><i className="bi bi-check-circle-fill pe-2"></i> Marcar pago</a> ) }
                            {/* FALTA DE PAGO */}
                            <a className="dropdown-item" href="#"
                            onClick={ () =>{
                              const nombre_compania = (typeof initData.companies !== 'undefined') ? initData.companies.filter( company => company.id_compania == t.id_compania)[0].nombre : '';
                              setNombreCompania(nombre_compania);
                              setDataSelected(t);
                              handleShowModalFaltaPago();
                            } }
                            ><i className="bi bi-exclamation-triangle-fill pe-2"></i> Falta Pago</a>
                            {/* VER RECIBO */}
                            <a className="dropdown-item" href="#" 
                            onClick={ () => {
                              handleShowModalRecibo(t);
                            } } ><i className="bi bi-file-text-fill pe-2"></i> Ver Recibo</a>
                            {/* CANCELAR PÓLIZA */}
                            <a className="dropdown-item" href="#"
                            onClick={ () => {
                              setDataSelected(t);
                              handleShowModalCancelarPoliza();
                            } } 
                            ><i className="bi bi-x-circle-fill pe-2"></i> Cancelar Póliza</a>

                          </div>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))
              )
            }

          </tbody>
          </Table>

          <ModalFaltaPago 
          show={modalFaltaPago} 
          handleClose={handleCloseModalFaltaPago}
          dataPoliza={dataSelected}
          company={nombreCompania}
          showToast={showToast}
          />

          <ModalCancelarPoliza 
          initState={state}
          initSetState={setState}
          show={modalCancelarPoliza}
          handleClose={handleCloseModalCancelarPoliza}
          dataPoliza={dataSelected}
          showToast={showToast}
          section={section}
          />

          <ModalConfirmacion 
          show={modalConfirmacion} 
          message={<p className="mb-0">¿Deseas eliminar el pago de la póliza: <b>{numeroPoliza}</b>?</p>} 
          handleDelete={ quitarPago }
          handleCancel={ handleCloseModalConfirmacion }
          isLoading={stateRecibo.isLoading}
          textConfirm={'Si, eliminar pago'}
          textCancel={'Cerrar'}
          />

          <ModalMarcarPago 
          initState={state}
          initSetState={setState}
          show={modalMarcarPago} 
          handleClose={handleCloseModalMarcarPago} 
          dataPoliza={dataSelected}
          company={nombreCompania}
          section={section}
          />

        </div>
      </Col>
    </Row>
  )
}

export default TablaRecibos;